import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { PATHS } from "@/lib/router";
import { Can } from "@/hooks/useCan/Can";
import { useAuthStore } from "@/features/auth/hooks";

const SurveyFormHeader = ({
  canManage,
  isPublished,
  submitting,
  loadingSurvey,
  isEdit,
}) => {
  const { t } = useTran();
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const permissions = user?.permissions || [];

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <Button
        type="button"
        variant="ghost"
        onClick={() => navigate(PATHS.SURVEYS)}
        className="flex items-center gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        {t("Back to Surveys")}
      </Button>
      {canManage && !isPublished ? (
        <Can resource="surveys" action={"update"} userPermissions={permissions}>
          <Button type="submit" disabled={submitting || loadingSurvey}>
            {submitting
              ? t("Saving...")
              : isEdit
                ? t("Update Survey")
                : t("Save Survey")}
          </Button>
        </Can>
      ) : null}
    </div>
  );
};

export default SurveyFormHeader;
